import { Injectable } from '@angular/core';
import { PiramidalService } from './piramidal.service';
import { SubcategoryGrouper } from '@core/models/piramide/SubcategoryGrouper';
import { Subcategory } from '@core/models/piramide/Subcategory';
import { Rescatable } from '@core/models/Rescatable';
import { Product } from '@core/models/piramide/Product';
import { Brand } from '@core/models/piramide/Brand';
import { ProductDetails } from '@core/models/piramide/ProductDetails';
import { Faqs } from '@core/models/piramide/Faqs';
import { Questions } from '@core/models/piramide/Questions';
import { FeaturesProduct } from '@core/models/piramide/FeaturesProduct';
import { SubcategoryBanner } from '@core/models/piramide/SubcategoryBanner';

export type relation<T, R> = {
  class: typeof Rescatable;
  foreinClass: typeof Rescatable;
  ownField: keyof T;
  foreinField?: keyof R;
  ownFieldIndex: keyof T;
  foreinFieldIndex: keyof R;
  unique?: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class PiramidalHookService {
  public indexes: { x: [relation<Rescatable, Rescatable>[]] } | {} = {};
  constructor() {
    const relationSubcategoriesSubcategoriesGroupers: relation<Subcategory, SubcategoryGrouper> = {
      class: Subcategory,
      foreinClass: SubcategoryGrouper,
      ownField: '$subcategoryGrouper',
      foreinField: '$subcatgories',
      ownFieldIndex: 'id_agrupador',
      foreinFieldIndex: 'id',
    };
    const relationSubcategoriesSubcategoryBanner: relation<Subcategory, SubcategoryBanner> = {
      class: Subcategory,
      foreinClass: SubcategoryBanner,
      ownField: '$bannersSubcategorias',
      foreinField: '$subcatgories',
      ownFieldIndex: 'id',
      foreinFieldIndex: 'idSubCate',
    };
    const relationProductSubcategory: relation<Product, Subcategory> = {
      class: Product,
      foreinClass: Subcategory,
      ownField: '$subcategory',
      foreinField: '$products',
      ownFieldIndex: 'id_subcategoria',
      foreinFieldIndex: 'id',
    };

    const relationProductFeatures: relation<Product, FeaturesProduct> = {
      class: Product,
      foreinClass: FeaturesProduct,
      ownField: '$features',
      ownFieldIndex: 'id_producto',
      foreinFieldIndex: 'id_producto',
      unique: true,
    };

    const relationProductBrand: relation<Product, Brand> = {
      class: Product,
      foreinClass: Brand,
      ownField: '$brand',
      foreinField: '$products',
      ownFieldIndex: 'id_marca',
      foreinFieldIndex: 'id',
    };

    const relationProductProducDetails: relation<Product, ProductDetails> = {
      class: Product,
      foreinClass: ProductDetails,
      ownField: '$details',
      foreinField: '$product',
      ownFieldIndex: 'id_producto',
      foreinFieldIndex: 'id_producto',
      unique: true,
    };

    const relationFaqsPadreFaqs: relation<Faqs, Faqs> = {
      class: Faqs,
      foreinClass: Faqs,
      ownField: '$padre',
      foreinField: '$hijos',
      ownFieldIndex: 'id_ayuda_pregunta_padre',
      foreinFieldIndex: 'id',
      unique: false,
    };

    /*const relationQuestionsProduct: relation<Questions, Product> = {
      class: Questions,
      foreinClass: Product,
      ownField: '$product',
      ownFieldIndex: 'id_producto',
      foreinFieldIndex: 'id_producto',
      unique: true
    };*/

    const relationQuestionsHijosQuestions: relation<Questions, Questions> = {
      class: Questions,
      foreinClass: Questions,
      ownField: '$padre',
      foreinField: '$hijos',
      ownFieldIndex: 'id_productos_preguntas_padre',
      foreinFieldIndex: 'id',
      unique: false,
    };

    this.indexes[SubcategoryGrouper._name] = [relationSubcategoriesSubcategoriesGroupers];
    this.indexes[SubcategoryBanner._name] = [relationSubcategoriesSubcategoryBanner];
    this.indexes[Subcategory._name] = [
      relationSubcategoriesSubcategoriesGroupers,
      relationProductSubcategory,
      relationSubcategoriesSubcategoryBanner,
    ];
    this.indexes[Product._name] = [
      relationProductSubcategory,
      relationProductBrand,
      relationProductProducDetails,
      relationProductFeatures,
    ];
    this.indexes[FeaturesProduct._name] = [relationProductFeatures];
    this.indexes[ProductDetails._name] = [relationProductProducDetails];

    this.indexes[Brand._name] = [relationProductBrand];
    this.indexes[Faqs._name] = [relationFaqsPadreFaqs];
    this.indexes[Questions._name] = [
      relationQuestionsHijosQuestions,
      //relationQuestionsProduct
    ];
  }
}
